import { ctx } from '../canvas.js';
import { state } from '../state.js';

// Buildings carry their own offscreen canvas, so drawing the city each frame is
// a cheap drawImage per building.
export function drawBuildings() {
  state.buildings.forEach(b => ctx.drawImage(b.canvas, b.x, b.y));
}
